import React, { useState, createContext, useContext } from 'react';
// Define the booking context type
type BookingContextType = {
  bookingDetails: any | null;
  setBookingDetails: (details: any) => void;
  clearBookingDetails: () => void;
};
// Create the context
const BookingContext = createContext<BookingContextType | undefined>(undefined);
// Booking provider component
export const BookingProvider = ({
  children
}) => {
  const [bookingDetails, setBookingDetails] = useState(null);
  const clearBookingDetails = () => {
    setBookingDetails(null);
  };
  return <BookingContext.Provider value={{
    bookingDetails,
    setBookingDetails,
    clearBookingDetails
  }} data-id="element-628">
      {children}
    </BookingContext.Provider>;
};
// Custom hook to use the booking context
export const useBooking = () => {
  const context = useContext(BookingContext);
  if (context === undefined) {
    throw new Error('useBooking must be used within a BookingProvider');
  }
  return context;
};